import { secondsToTimelineTime } from '~/Util'

/**
 * @memberOf ProjectData
 */
class Project {

  // eslint-disable-next-line no-unused-vars
  constructor(jsonData, layers) {
    const {
      version,
      timeline,
      thumbnail,
      modifTime,
      reference,
      ioPoints,
      timecodeFormat,
      fileIds = [],
      defaultTransitionDuration = secondsToTimelineTime(3),
    } = jsonData
    const { sliderTime, scale, scrollLeft } = timeline

    this._version = version
    this._timeline = { sliderTime, scale, scrollLeft }
    this._layers = layers
    this._thumbnail = thumbnail
    this._modifTime = modifTime
    this._reference = reference
    this._ioPoints = ioPoints
    this._defaultTransitionDuration = defaultTransitionDuration
    this._timecodeFormat = timecodeFormat
    this._fileIds = fileIds
  }

  /**
   * @returns {Object}
   */
  get reference() {
    return this._reference
  }

  /**
  * @param {Object} value
  */
  set reference(value) {
    this._reference = value
  }

  /**
   * @returns {number}
   */
  get modifTime() {
    return this._modifTime
  }

  /**
   * @returns {string}
   */
  get version() {
    return this._version
  }

  /**
   * @returns {object}
   */
  get timeline() {
    return this._timeline
  }

  /**
   * @returns {ProjectData.ProjectLayer[]}
   */
  get layers() {
    return this._layers
  }

  /**
   * @returns {string}
   */
  get thumbnail() {
    return this._thumbnail
  }

  /**
   * @returns {object}
   */
  get ioPoints() {
    return this._ioPoints
  }

  /**
   * @returns {object}
   */
  get timecodeFormat() {
    return this._timecodeFormat
  }

  /**
   * @returns {number}
   */
  get defaultTransitionDuration() {
    return this._defaultTransitionDuration
  }

  /**
   * @param {number} duration
   */
  set defaultTransitionDuration(duration) {
    this._defaultTransitionDuration = duration
  }

  /**
   * @returns {number[]}
   */
  get fileIds() {
    return this._fileIds
  }

  /**
   * @param {number[]} fileIds
   */
  set fileIds(fileIds) {
    this._fileIds = fileIds
  }

}

export default Project
